import React from 'react';
import { createPortal } from 'react-dom';
import { Background, Body, Header, Title } from './style';
import { AiOutlineClose } from 'react-icons/ai';

interface ModalProps {
  open: boolean;
  toggle?: () => void;
  isOpenSidebar?: boolean;
  title?: React.ReactNode;
  bgColor?: string;
  children?: React.ReactNode;
  hideToggleBtn?: boolean;
  modalClassName?: string;
  modalBodyClassName?: string;
}

const Modal = ({
  open,
  toggle,
  title,
  bgColor,
  children,
  hideToggleBtn = false,
  modalClassName = '',
  modalBodyClassName = ''
}: ModalProps) => {
  if (!open) return;

  return createPortal(
    <Background className={modalClassName}>
      <Body
        className={modalBodyClassName}
        style={{
          backgroundColor: bgColor || 'white'
        }}
      >
        <Header>
          <Title>{title}</Title>
          {!hideToggleBtn && (
            <AiOutlineClose data-testid="close-icon" onClick={toggle} className="toggler" />
          )}
        </Header>
        {children}
      </Body>
    </Background>,
    document.body
  );
};

export default Modal;
